import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DurationModule } from '@y42/date-time';
import { DurationCellRendererComponent } from './duration-cell-renderer.component';

@NgModule({
  declarations: [DurationCellRendererComponent],
  imports: [CommonModule, DurationModule],
  exports: [DurationCellRendererComponent],
})
export class DurationCellRendererModule {}
